export const submissionResponseSelector = ({ submission = {} } = {}) => submission.response;
